export default __webpack_public_path__ + "static/media/habrImg4.47f3b90f.png";